import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-gray-600 py-2 mt-auto border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-xs">
            © 2025 Pithad Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
